import { useDispatch } from 'react-redux';
import {
  DealerProfileType,
  FFLDealerProfile,
  TransferCountType
} from '@masterffl/dealer-profile-component';

import { Button, useDisclosure } from '@chakra-ui/react';
import { BLACKLIST_ERROR, optOutExploreMessage } from '@/utils/constants';
import {
  getDealerOptOutValue,
  getIsDealerProfileEditEmailSended,
  getIsSendingDealerProfileEditEmail,
  getIsCreateDealerActionCompleted,
  getIsCreateDealerActionInprogress,
  getRefreshSerpEnrichmentLoading,
} from '@/explore/ducks/selectors';
import TransferModal from '@/dealerProfile/modals/TransferForm';
import { ErrorToasterNotification } from '@/toaster/successNotification';
import { getIsGlobalOperations, getIsMyFFLRole, getStoreId, getIsSearchOnlyRole, 
  getIsStoreAgent, getIsGlobalAdmin, getIsStoreAdmin, 
  getIsStoreAdminRole, getIsGlobalAdminRole,
  getIsImpersonating} from '@/redux/app-selectors';
import ConfirmationModal from '@/common/ConfirmationModal';
import { callToCreateDealerAction, callToRemoveLicense, callToSendProfileEditEmail, setIsDealerProfileEditEmailSended, callToRefreshSerpEnrichment } from '@/explore/ducks/slice';
import OptInModal from './modals/OptInForm';
import SotTaxStampUploadModal from './SotTaxStampUploadModal';
import UploadLicenseModal from './modals/uploadLicenseModal';
import { useEffect, useState } from 'react';
import SocialLinksEditModal from '@/dealerProfile/edit-dealer-profile/SocialLinksEdit';
import ServicesEditModal from '@/dealerProfile/edit-dealer-profile/ServicesEdit';
import { ezCheck, getEightDigitLicenseKey, getPrimary } from '@/explore/ffl-detail/utils.mjs';
import StoreContactDetailsEdit from '@/dealerProfile/edit-dealer-profile/StoreContactDetailsEdit';
import StoreTransferEdit from '@/dealerProfile/edit-dealer-profile/StoreTransferEdit';
import UpdateClosedStatusModal from '@/dealerProfile/edit-dealer-profile/UpdateClosedStatusModal';
// import UpdateOpenStatusConfirmModal from '@/dealerProfile/edit-dealer-profile/UpdateOpenStatusConfirmModal';
import {  getIsPreferredLicense, getIsEmailNotFoundLoading } from './ducks/selectors';
import { callToEmailNotFound, certificateWorkflowInitialState, setIsNewProfileLicenseRemoved, setIsPreferredLicense, setOcrStepFunctionStatusV2 } from './ducks/slice';
import LOAUploadModal from '@/dealerProfile/edit-dealer-profile/LOAUploadModal';
import LicenseAttributesEditModal from './modals/LicenseAttributesEditModal';
import EditSOT from './edit-sot';
import SotEnableModal from './modals/SotEnableModal';
import { ToasterNotification } from '@/toaster/toasterNotification';
import BioEditModal from './edit-dealer-profile/BioEdit';
import { useLocation, useNavigate } from "react-router-dom";
import { logAnalyticsEvent } from '@/utils/analyticsLogger';
import { analyticsEvents } from '@/utils/analyticsEvents';
import PreferredModal from './modals/PreferredModal';
import BlacklistedModal from './modals/BlacklistedModal';
import BigBoxRetailerModal from './modals/BigBoxRetailerModal';


type Props = {
  isSuperAdmin: boolean;
  isLoading?: boolean;
  data: DealerProfileType;
  transferCount?: TransferCountType;
  dealerId?: string;
  handleFetch?: () => void
  isEditable: boolean
};

const DealerProfileModule = ({
  isSuperAdmin,
  isLoading,
  data,
  handleFetch,
  transferCount,
  dealerId,
  isEditable
}: Props) => {
  const dispatch = useDispatch();
  const isMyFFLRole = getIsMyFFLRole();
  const isGlobalAdmin = getIsGlobalAdmin();
  const isGlobalOperations = getIsGlobalOperations();
  const isStoreAdmin = getIsStoreAdmin()
  const isStoreAgent = getIsStoreAgent()
  const isGlobalAdminRole = getIsGlobalAdminRole()
  const isStoreAdminRole = getIsStoreAdminRole()
  const storeId = getStoreId()
  const isSendingDealerProfileEditEmail = getIsSendingDealerProfileEditEmail();
  const isPreferredLicense = getIsPreferredLicense()
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const [selectedLicense, setSelectedLicense] = useState({})
  const [licenseKeyForLOA, setLicenseKeyForLOA] = useState('')
  // const isLicenseRemoved = getIsLicenseRemoved();
  const refreshSerpEnrichmentLoading = getRefreshSerpEnrichmentLoading();
  const isSearchOnlyRole = getIsSearchOnlyRole();
  const location = useLocation();
  const [isEmailSearch, setIsEmailSearch] = useState(false)
  const [isEmailSearchForAdminAgent, setIsEmailSearchForAdminAgent] = useState(false)
  const isEmailButtonLoading = getIsEmailNotFoundLoading();
  const [isEmailDisabled, setIsEmailDisabled] = useState(false)  
  const [removeLicenseKey, setRemoveLicenseKey] = useState<string>('')  
  const [removeLOALicenseKey, setRemoveLOALicenseKey] = useState<string>('')  
  const [removeSOTControllerKey, setRemoveSOTControllerKey] = useState<string>('')  
  const [bounceEmailMarkedAsValid, setBounceEmailMarkedAsValid] = useState<string>(``);
  const [loadingEmail, setLoadingEmail] = useState<string>(``);
  const isImpersonating = getIsImpersonating();

  useEffect(() => {
    if (bounceEmailMarkedAsValid){
      setLoadingEmail(bounceEmailMarkedAsValid);
      const hasAnyValidEmail = data.businessDetails?.emails?.some(emailObj => emailObj.isPrimary && !emailObj.bounced) || false;
      const payload: any = {
        actionList: [{
          name: 'mark_email_valid',
          value: bounceEmailMarkedAsValid,
          type: 'update',
          license_key: getEightDigitLicenseKey(data.primaryInboundDetails.licenseKey)
        },
        ...(!hasAnyValidEmail ? [{
          name: 'is_primary_email',
          value: bounceEmailMarkedAsValid,
          type: 'add',
          license_key: getEightDigitLicenseKey(data.primaryInboundDetails.licenseKey)
        }] : [])
      
      ],
        dealerId: dealerId
      };
      dispatch(callToCreateDealerAction(payload));
      setBounceEmailMarkedAsValid(``)
    }
  },[bounceEmailMarkedAsValid])

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paramValue = params.get("isEmailSearch");
    if (paramValue) {
      setIsEmailSearch(true)
    }
    const paramValueForAgentAdmin = params.get("isEmailSearchForAdminAgent");
    if (paramValueForAgentAdmin) {
      console.log("paramValueForAgentAdmin : ", paramValueForAgentAdmin);
      console.log("isStoreAdmin : ", isStoreAdmin);
      console.log("isStoreAdminRole : ", isStoreAdminRole);
      console.log("COND : ", isStoreAdmin && !isStoreAdminRole);
      if(isStoreAdmin && !isStoreAdminRole){
        setIsEmailSearch(true)
      } else {
        setIsEmailSearchForAdminAgent(true)
      }
    }
  }, [location]);

  useEffect(() => {
    if (data) {
      dispatch(setIsPreferredLicense({ license: data.primaryInboundDetails.licenseKey, isLoading: false, isChecked: true }))
    }
  }, [data])

  useEffect(() => {
    dispatch(setIsNewProfileLicenseRemoved(false))
    const isEmailDisabledFlag = localStorage.getItem('emailNotFound');
    setIsEmailDisabled(isEmailDisabledFlag == 'true' ? true : false)
  }, [])

  useEffect(() => {
    const isEmailDisabledFlag = localStorage.getItem('emailNotFound');
    setIsEmailDisabled(isEmailDisabledFlag == 'true' ? true : false)
  }, [isEmailButtonLoading])

  useEffect(() => {
    if (!isCreateDealerActionInprogress && isCreateDealerActionCompleted) {
      setLoadingEmail('');
      dispatch(setIsPreferredLicense({ license: data.primaryInboundDetails.licenseKey, isLoading: false, isChecked: true }))
    }
  }, [isCreateDealerActionInprogress, isCreateDealerActionCompleted])
  //for transfer modal
  const {
    isOpen: isTransferOpen,
    onOpen: onTransferOpen,
    onClose: onTransferClose
  } = useDisclosure();

  //for Opt IN/OUT modal
  const {
    isOpen: isOptInModalOpen,
    onClose: onOptInModalClose,
    onOpen: onOptInModalOpen
  } = useDisclosure();

  //for sot modal
  const {
    isOpen: isSotOpen,
    onClose: onCloseSot,
    onOpen: onSotOpen
  } = useDisclosure();

  const {
    isOpen: isSotEnableModalOpen,
    onClose: onSotEnableModalClose,
    onOpen: onSotEnableModalOpen
  } = useDisclosure();

  const {
    isOpen: isLicenseModalOpen,
    onClose: onCloseLicenseModal,
    onOpen: onLicenseModalOpen
  } = useDisclosure();

  const {
    isOpen: isLicenseEditModalOpen,
    onClose: onCloseLicenseEditModal,
    onOpen: onLicenseEditModalOpen
  } = useDisclosure()
  const {
    isOpen: iscontactDetailsEditOpen,
    onOpen: oncontactDetailsEditOpen,
    onClose: oncontactDetailsEditClose
  } = useDisclosure();

  const {
    isOpen: isTransferServicesEditOpen,
    onOpen: onTransferServicesEditOpen,
    onClose: onTransferServicesEditClose
  } = useDisclosure();
  //for services edit
  const {
    isOpen: isServicesEditOpen,
    onOpen: onServicesEditOpen,
    onClose: onServicesEditClose
  } = useDisclosure();
  //for send mail
  const {
    isOpen: isProfileModalOpen,
    onClose: onCloseProfileModal,
    onOpen: onOpenProfileModal
  } = useDisclosure();
  //to edit social links
  const {
    isOpen: isSocialEditOpen,
    onClose: onSocialEditClose,
    onOpen: onSocialEditOpen
  } = useDisclosure();
  // to edit business description
  const {
    isOpen: isBioEditOpen,
    onClose: onBioEditClose,
    onOpen: onBioEditOpen
  } = useDisclosure();
  //for changing closed status
  const {
    isOpen: isUpdateClosedStatusModelOpen,
    onClose: onUpdateClosedStatusModelClose,
    onOpen: onUpdateClosedStatusModelOpen
  } = useDisclosure();
  //for changing closed status
  const {
    isOpen: isUpdateOpenStatusConfirmOpen,
    onClose: onUpdateOpenStatusConfirmClose,
    onOpen: onUpdateOpenStatusConfirmOpen
  } = useDisclosure();

  const {
    isOpen: isEditSOTModalOpen,
    onClose: onCloseEditSOTModal,
    onOpen: onOpenEditSOTModal
  } = useDisclosure();

  const {isOpen: isBlacklistedModalOpen, onClose: onBlacklistedModalClose, onOpen: onBlacklistedModalOpen} = useDisclosure()
  const {isOpen: isPreferredModalOpen, onClose: onPreferredModalClose, onOpen: onPreferredModalOpen} = useDisclosure()
  const {isOpen: isBigBoxRetailerModalOpen, onClose: onBigBoxRetailerModalClose, onOpen: onBigBoxRetailerModalOpen} = useDisclosure()

  //for transfer modal
  const onTransferOpenHandler = () => {
    const isBlacklisted = data.businessDetails?.blacklistedStores?.includes(storeId) ;
    const isOptedOut = () => {
      if (data.businessDetails.isOptInForStore) return false;
      if (data.businessDetails.isOptOutForStore) return true;
      return data.businessDetails.isOptInForAll
        ? false
        : data.businessDetails.isOptOutForAll
          ? true
          : false;
    }
    const dealerErrorMsg =
      optOutExploreMessage[
      data.businessDetails.isOptOutForStore ? 'store' : ('all' as KeyType)
      ];
    let errorMsg = '';
    if (isBlacklisted && isOptedOut()) {
      errorMsg = `${BLACKLIST_ERROR}, ${dealerErrorMsg}`;
    } else if (isBlacklisted) {
      errorMsg = BLACKLIST_ERROR;
    } else if (
      data.businessDetails.isOptOutForStore ||
      data.businessDetails.isOptOutForAll
    ) {
      errorMsg = dealerErrorMsg;
    }
    if ((errorMsg && isBlacklisted) || isOptedOut()) {
      ErrorToasterNotification(errorMsg);
    } else {
      onTransferOpen();
    }
  };
  //for mail function
  const onClickConfirmBtn = () => {
    logAnalyticsEvent(analyticsEvents.sendProfileToDealer);
    dispatch(
      callToSendProfileEditEmail({
        license_key: data?.primaryInboundDetails.licenseKey
      })
    );
  };
  const onCheckIsPreferredLicense = (licenseKey: string, isChecked: boolean) => {
    if (data?.licenses[0]?.licenseKey !== licenseKey) {
      dispatch(setIsPreferredLicense({ license: licenseKey, isLoading: true, isChecked: isChecked }))
      const payload: any = {
        actionList: [{
          name: 'is_primary_license',
          value: isChecked,
          type: 'isPrimary',
          license_key: licenseKey
        }],
        dealerId: dealerId
      };
      console.log({ payload });
      dispatch(callToCreateDealerAction(payload));
    }
  }

  function handleEzCheck(license_key: string) {
    logAnalyticsEvent(analyticsEvents.ezCheckOnDealerProfile)
    ezCheck(dispatch, { license_key });
  }

  const onLicenseUploadHandler = (licenseData: any) => {
    setSelectedLicense(licenseData)
    logAnalyticsEvent(analyticsEvents.licenseUpload);
    dispatch(setOcrStepFunctionStatusV2(certificateWorkflowInitialState));
    onLicenseModalOpen()
  }
  const onLicenseAttributeEditHandler = (licenseData: any) => {
    if(isEditable){
    setSelectedLicense(licenseData)
    logAnalyticsEvent(analyticsEvents.editLicense)
    onLicenseEditModalOpen()
    }
  }
  const toggleEditSocialLinks = () => {
    onSocialEditOpen()
  }

  //for OptIn/Out
  const onOptInOpenHandler = () => {

    onOptInModalOpen();
  }

  const DealerProfileEditEmailSended = () => {
    dispatch(setIsDealerProfileEditEmailSended(false));
    onCloseProfileModal();
  }

  const RemoveLicense = (licenseKey: string) => {
    setRemoveLicenseKey(licenseKey)
    dispatch(callToRemoveLicense({ license_key: licenseKey, dealerId, type:'FFL' }))
  }
  const RemoveSOT = (licenseKey: string, controlNumber: string) => {
    setRemoveSOTControllerKey(controlNumber)
    dispatch(callToRemoveLicense({ license_key: licenseKey, dealerId, type:'SOT' }))
  }
  const RemoveLOA = (licenseKey: string) => {
    setRemoveLOALicenseKey(licenseKey)
    dispatch(callToRemoveLicense({ license_key: licenseKey, dealerId, type:'LOA' }))
  }
  const onEditSOTHandler = () => {
    logAnalyticsEvent(analyticsEvents.editDealerSOT);
    onOpenEditSOTModal()
  }

  const refreshSerpEnrichment = (licenseKey: string) => {
    if (!refreshSerpEnrichmentLoading) {
      dispatch(callToRefreshSerpEnrichment({ license_key: licenseKey }))
      ToasterNotification("success", "We are processing your request to enrich the SERP data. This will take a few minutes to complete, kindly check the profile after 5 minutes.");
    }
  }
  const showDealerTransfers = () => {
    window.open(
      `/transfers/?dealer_id=${data?._id}`,
      '_blank'
    );
  }

  useEffect(() => {
    if (!isCreateDealerActionInprogress && isCreateDealerActionCompleted && handleFetch) {
      handleFetch()
    }
  }, [isCreateDealerActionCompleted, isCreateDealerActionInprogress])

  const emailNotFoundClick = () => {
    dispatch(callToEmailNotFound(data?._id))
  }
  const isBlacklistedStore = data.businessDetails?.blacklistedStores?.includes(storeId) ;

  const onClickCreateTransferHandler = ()=>{
    logAnalyticsEvent(analyticsEvents.manualInitiateTransfer);
    onTransferOpenHandler();
  }

  const onClickContactDetailsEditHandler = ()=>{
    logAnalyticsEvent(analyticsEvents.editDealerContactDetails);
    oncontactDetailsEditOpen();
  }

  const showDealerTransfersHandler = ()=> { 
    logAnalyticsEvent(analyticsEvents.showTransferCount);
    showDealerTransfers();
  }

  const onServicesEditButtonClickHandler =()=>{
    logAnalyticsEvent(analyticsEvents.editDealerServices);
    onServicesEditOpen();
  }

  const onClickOptInHandler =()=> {
    logAnalyticsEvent(analyticsEvents.editDealerOptIn);
    onOptInOpenHandler();
  }

  const onClickSOTUploadHandler =()=> {
    logAnalyticsEvent(analyticsEvents.sotUpload);
    dispatch(setOcrStepFunctionStatusV2(certificateWorkflowInitialState));
    onSotOpen();
  }

  const onClickEditSocialButtonHandler =()=>{
    logAnalyticsEvent(analyticsEvents.editDealerSocialLinks);
    toggleEditSocialLinks();
  }

  const onClickBioHandler =()=>{
    logAnalyticsEvent(analyticsEvents.editDealerBusinessDescription);
    onBioEditOpen();
  }

  const licensePreviewHandler =(name: string)=>{
    if (name=== 'license') logAnalyticsEvent(analyticsEvents.previewLicense);
    if (name=== 'sot') logAnalyticsEvent(analyticsEvents.previewSOT);
    if (name=== 'loa') logAnalyticsEvent(analyticsEvents.previewLOA);
  }

  const onViewActiveLog = (licenseKey: string) => {
    const params = new URLSearchParams();
    if (licenseKey) params.set('licenseKey', getEightDigitLicenseKey(licenseKey));
    if (dealerId) params.set('dealerId', dealerId);
    const query = params.toString() ? `?${params.toString()}` : '';
    const url = `${window.location.origin}/activity-logs${query}`;
    window.open(url, '_blank');
  }

  return (
    <div>
      <TransferModal
        isOpen={isTransferOpen}
        onClose={onTransferClose}
        dealerDetail={data}
      />
      <ServicesEditModal open={isServicesEditOpen} close={onServicesEditClose} details={data} />

      <SocialLinksEditModal details={data} open={isSocialEditOpen} close={() => onSocialEditClose()} />
      <BioEditModal details={data} open={isBioEditOpen} close={() => onBioEditClose()} />
      <OptInModal
        isOpen={isOptInModalOpen}
        onClose={onOptInModalClose}
        onOpen={onOptInModalOpen}
        data={data}
      />
      <UploadLicenseModal data={selectedLicense} isOpen={isLicenseModalOpen} onClose={onCloseLicenseModal} />
      <LicenseAttributesEditModal data={selectedLicense} dealerDetails={data} open={isLicenseEditModalOpen} close={() => onCloseLicenseEditModal()} />
      <SotTaxStampUploadModal data={data} isOpen={isSotOpen} onClose={onCloseSot} />
      <SotEnableModal
        isOpen={isSotEnableModalOpen}
        onClose={onSotEnableModalClose}
        data={data}
      />
      <LOAUploadModal data={data} licenseKeyForLOA={licenseKeyForLOA} setLicenseKeyForLOA={setLicenseKeyForLOA} />
      <ConfirmationModal
        isOpen={isProfileModalOpen}
        onClose={onCloseProfileModal}
        modalHeader={'Email Confirmation!'}
        isCancelBtnDisable={isSendingDealerProfileEditEmail}
        isConfirmBtnDisable={isSendingDealerProfileEditEmail}
        isConfirmBtnLoading={isSendingDealerProfileEditEmail}
        onClickConfirmBtn={onClickConfirmBtn}
        modalContent={
          <>
            Are you sure you want to send a profile edit link to this dealer "
            {getPrimary(data.businessDetails.emails ?? []) || ''}"?
          </>
        }
      />
      <UpdateClosedStatusModal
        details={data}
        open={isUpdateClosedStatusModelOpen}
        close={onUpdateClosedStatusModelClose}
      />
      <BlacklistedModal isOpen={isBlacklistedModalOpen} onClose={onBlacklistedModalClose} onOpen={onBlacklistedModalOpen} data={data}/>
      <PreferredModal isOpen={isPreferredModalOpen} onClose={onPreferredModalClose} onOpen={onPreferredModalOpen} data={data}/>
      <BigBoxRetailerModal isOpen={isBigBoxRetailerModalOpen} onClose={onBigBoxRetailerModalClose} onOpen={onBigBoxRetailerModalOpen} data={data}/>
      {iscontactDetailsEditOpen && (
        <StoreContactDetailsEdit
          iscontactDetailsEditOpen={iscontactDetailsEditOpen}
          oncontactDetailsEditClose={oncontactDetailsEditClose}
          dealerDetail={data}
          dealerId={dealerId || ''}
        />
      )}

      {isTransferServicesEditOpen && (
        <StoreTransferEdit
          isTransferServicesEditOpen={isTransferServicesEditOpen}
          onTransferServicesEditClose={onTransferServicesEditClose}
          dealerDetail={data}
          dealerId={dealerId || ''}
        />
      )}
      <FFLDealerProfile
        DealerProfileEditEmailSended={DealerProfileEditEmailSended}
        getIsDealerProfileEditEmailSended={getIsDealerProfileEditEmailSended}
        onOpenProfileModal={onOpenProfileModal}
        isMyFFLRole={isMyFFLRole}
        toggleDealerStatus={onUpdateClosedStatusModelOpen}
        isLoading={isLoading ? true : !data._id ? true : false}
        isSuperAdmin={isSuperAdmin}
        isGlobalOperations={isGlobalOperations}
        onClickCreateTransfer={onClickCreateTransferHandler}
        onClickContactDetailsEdit={onClickContactDetailsEditHandler}
        onLicenseAttributeEditHandler={(license: any) =>
          onLicenseAttributeEditHandler(license)
        }
        onLicenseUploadHandler={(license: any) =>
          onLicenseUploadHandler(license)
        }
        onClickTransferServicesEdit={onTransferServicesEditOpen}
        data={data}
        onClickBio={onClickBioHandler}
        transferCount={transferCount}
        handleEzCheck={handleEzCheck}
        onClickEditSocialButton={onClickEditSocialButtonHandler}
        onClickSOTUpload={onClickSOTUploadHandler}
        onClickSOT={onSotEnableModalOpen}
        onClickLOA={setLicenseKeyForLOA}
        preferredLicense={isPreferredLicense} setPreferredLicense={onCheckIsPreferredLicense}
        onClickOptIn={onClickOptInHandler} isGlobalAdmin={isGlobalAdmin}
        onServicesEditButtonClick={onServicesEditButtonClickHandler}
        onLicenseDelete={(key: string) => RemoveLicense(key)}
        editSOTClickHandler={onEditSOTHandler}
        refreshSerpEnrichment={refreshSerpEnrichment}
        showDealerTransfers={showDealerTransfersHandler}
        isSearchOnlyRole={isSearchOnlyRole}
        isEmailButtonLoading={isEmailButtonLoading}
        isEmailButtonShow={isEmailSearch}
        isEmailButtonDisabled={isEmailDisabled}
        emailNotFoundClick={emailNotFoundClick}
        licensePreviewLogEventHandler={licensePreviewHandler}
        onClickBlacklisted={onBlacklistedModalOpen}
        onClickPreferred={onPreferredModalOpen}
        onClickBigBoxRetailer={onBigBoxRetailerModalOpen}
        isStoreAdmin={isStoreAdmin}
        isBlacklistedStore={isBlacklistedStore}
        isStoreAgent={isStoreAgent}
        isEmailSearchForAdminAgent={isEmailSearchForAdminAgent}
        isStoreAdminRole={isStoreAdminRole}
        removeLicenseKey={removeLicenseKey}
        isEditable={isEditable}
        removeSOTControlNumber={removeSOTControllerKey}
        removeLOALicenseKey={removeLOALicenseKey}
        onSOTDelete={(key: string, controlNumber: string) => RemoveSOT(key, controlNumber)}
        onLOADelete={(key: string) => RemoveLOA(key)}
        markBounceEmailAsValid={setBounceEmailMarkedAsValid}
        loadingEmail={loadingEmail}
        isImpersonating={isImpersonating}
        isGlobalAdminRole= {isGlobalAdminRole}
        onClickViewActionLog={(licenseKey: string) => onViewActiveLog(licenseKey)}
      />
      {isEditSOTModalOpen &&
        <EditSOT isOpen={isEditSOTModalOpen} onClose={onCloseEditSOTModal} sotDetails={data.sot} dealerId={data._id} />
      }
    </div>
  );
};

export default DealerProfileModule;


